/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { DeliveryStartOrdersDto } from '../model/deliveryStartOrdersDto';
import { EnumsOrderState } from '../model/enumsOrderState';
import { EnumsPaymentMethod } from '../model/enumsPaymentMethod';
import { LastOrdersDto } from '../model/lastOrdersDto';
import { OrderForDeliveryPayingDto } from '../model/orderForDeliveryPayingDto';
import { OrderForStorePayingDto } from '../model/orderForStorePayingDto';
import { OrderOutputDto } from '../model/orderOutputDto';
import { OrderPostDto } from '../model/orderPostDto';
import { OrderReceiptDto } from '../model/orderReceiptDto';
import { OrdersListDto } from '../model/ordersListDto';
import { OrdersToListDto } from '../model/ordersToListDto';
import { PendingPaymentsDto } from '../model/pendingPaymentsDto';
import { SalesDeliveryReportDto } from '../model/salesDeliveryReportDto';
import { SalesStoreReportDto } from '../model/salesStoreReportDto';
import { TotalOrdersDto } from '../model/totalOrdersDto';
import { UserOrdersDto } from '../model/userOrdersDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable({
    providedIn: 'root'
})
export class OrderService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdOrder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderAceptDeliveryPut(cdOrder?: number, observe?: 'body', reportProgress?: boolean): Observable<OrderOutputDto>;
    public apiOrderAceptDeliveryPut(cdOrder?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderOutputDto>>;
    public apiOrderAceptDeliveryPut(cdOrder?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderOutputDto>>;
    public apiOrderAceptDeliveryPut(cdOrder?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OrderOutputDto>('put', `${this.basePath}/api/Order/AceptDelivery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param cdDelivery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderAssingDeliveryPut(cdOrder?: number, cdDelivery?: number, observe?: 'body', reportProgress?: boolean): Observable<OrderOutputDto>;
    public apiOrderAssingDeliveryPut(cdOrder?: number, cdDelivery?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderOutputDto>>;
    public apiOrderAssingDeliveryPut(cdOrder?: number, cdDelivery?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderOutputDto>>;
    public apiOrderAssingDeliveryPut(cdOrder?: number, cdDelivery?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }
        if (cdDelivery !== undefined && cdDelivery !== null) {
            queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OrderOutputDto>('put', `${this.basePath}/api/Order/AssingDelivery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param dsNotes 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderCancelOrderPut(cdOrder?: number, dsNotes?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOrderCancelOrderPut(cdOrder?: number, dsNotes?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOrderCancelOrderPut(cdOrder?: number, dsNotes?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOrderCancelOrderPut(cdOrder?: number, dsNotes?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }
        if (dsNotes !== undefined && dsNotes !== null) {
            queryParameters = queryParameters.set('dsNotes', <any>dsNotes);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put', `${this.basePath}/api/Order/CancelOrder`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderConfirmDeliverPut(cdOrder?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOrderConfirmDeliverPut(cdOrder?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOrderConfirmDeliverPut(cdOrder?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOrderConfirmDeliverPut(cdOrder?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put', `${this.basePath}/api/Order/ConfirmDeliver`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param deliveryTime 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderConfirmOrderPut(cdOrder?: number, deliveryTime?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOrderConfirmOrderPut(cdOrder?: number, deliveryTime?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOrderConfirmOrderPut(cdOrder?: number, deliveryTime?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOrderConfirmOrderPut(cdOrder?: number, deliveryTime?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }
        if (deliveryTime !== undefined && deliveryTime !== null) {
            queryParameters = queryParameters.set('deliveryTime', <any>deliveryTime);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put', `${this.basePath}/api/Order/ConfirmOrder`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdDelivery 
     * @param dtFrom 
     * @param dtTo 
     * @param nmStatus 
     * @param filter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderDeliveryReportsGet(cdDelivery?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: number, filter?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SalesDeliveryReportDto>>;
    public apiOrderDeliveryReportsGet(cdDelivery?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: number, filter?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SalesDeliveryReportDto>>>;
    public apiOrderDeliveryReportsGet(cdDelivery?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: number, filter?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SalesDeliveryReportDto>>>;
    public apiOrderDeliveryReportsGet(cdDelivery?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: number, filter?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {






        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdDelivery !== undefined && cdDelivery !== null) {
            queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
        }
        if (dtFrom !== undefined && dtFrom !== null) {
            queryParameters = queryParameters.set('dtFrom', <any>dtFrom.toISOString());
        }
        if (dtTo !== undefined && dtTo !== null) {
            queryParameters = queryParameters.set('dtTo', <any>dtTo.toISOString());
        }
        if (nmStatus !== undefined && nmStatus !== null) {
            queryParameters = queryParameters.set('nmStatus', <any>nmStatus);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SalesDeliveryReportDto>>('get', `${this.basePath}/api/Order/DeliveryReports`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetActiveDailyByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrdersListDto>>;
    public apiOrderGetActiveDailyByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrdersListDto>>>;
    public apiOrderGetActiveDailyByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrdersListDto>>>;
    public apiOrderGetActiveDailyByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrdersListDto>>('get', `${this.basePath}/api/Order/GetActiveDailyByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllAcceptedByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrdersListDto>>;
    public apiOrderGetAllAcceptedByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrdersListDto>>>;
    public apiOrderGetAllAcceptedByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrdersListDto>>>;
    public apiOrderGetAllAcceptedByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrdersListDto>>('get', `${this.basePath}/api/Order/GetAllAcceptedByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllActiveGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OrderOutputDto>>;
    public apiOrderGetAllActiveGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderOutputDto>>>;
    public apiOrderGetAllActiveGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderOutputDto>>>;
    public apiOrderGetAllActiveGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderOutputDto>>('get', `${this.basePath}/api/Order/GetAllActive`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllByDeliveryGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OrderOutputDto>>;
    public apiOrderGetAllByDeliveryGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderOutputDto>>>;
    public apiOrderGetAllByDeliveryGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderOutputDto>>>;
    public apiOrderGetAllByDeliveryGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderOutputDto>>('get', `${this.basePath}/api/Order/GetAllByDelivery`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllCancelledByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrdersListDto>>;
    public apiOrderGetAllCancelledByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrdersListDto>>>;
    public apiOrderGetAllCancelledByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrdersListDto>>>;
    public apiOrderGetAllCancelledByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrdersListDto>>('get', `${this.basePath}/api/Order/GetAllCancelledByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllCompletedByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrdersListDto>>;
    public apiOrderGetAllCompletedByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrdersListDto>>>;
    public apiOrderGetAllCompletedByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrdersListDto>>>;
    public apiOrderGetAllCompletedByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrdersListDto>>('get', `${this.basePath}/api/Order/GetAllCompletedByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OrderOutputDto>>;
    public apiOrderGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderOutputDto>>>;
    public apiOrderGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderOutputDto>>>;
    public apiOrderGetAllGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderOutputDto>>('get', `${this.basePath}/api/Order/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllInactiveGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OrderOutputDto>>;
    public apiOrderGetAllInactiveGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderOutputDto>>>;
    public apiOrderGetAllInactiveGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderOutputDto>>>;
    public apiOrderGetAllInactiveGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderOutputDto>>('get', `${this.basePath}/api/Order/GetAllInactive`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllToConfirmOrCancelByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<OrdersToListDto>;
    public apiOrderGetAllToConfirmOrCancelByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrdersToListDto>>;
    public apiOrderGetAllToConfirmOrCancelByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrdersToListDto>>;
    public apiOrderGetAllToConfirmOrCancelByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OrdersToListDto>('get', `${this.basePath}/api/Order/GetAllToConfirmOrCancelByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetAllTravellingGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OrderOutputDto>>;
    public apiOrderGetAllTravellingGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderOutputDto>>>;
    public apiOrderGetAllTravellingGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderOutputDto>>>;
    public apiOrderGetAllTravellingGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderOutputDto>>('get', `${this.basePath}/api/Order/GetAllTravelling`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetDayilyCompletedByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrdersListDto>>;
    public apiOrderGetDayilyCompletedByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrdersListDto>>>;
    public apiOrderGetDayilyCompletedByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrdersListDto>>>;
    public apiOrderGetDayilyCompletedByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrdersListDto>>('get', `${this.basePath}/api/Order/GetDayilyCompletedByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetMpRejectedOrdersByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrdersListDto>>;
    public apiOrderGetMpRejectedOrdersByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrdersListDto>>>;
    public apiOrderGetMpRejectedOrdersByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrdersListDto>>>;
    public apiOrderGetMpRejectedOrdersByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrdersListDto>>('get', `${this.basePath}/api/Order/GetMpRejectedOrdersByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdorder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetOneGet(cdorder?: number, observe?: 'body', reportProgress?: boolean): Observable<OrderOutputDto>;
    public apiOrderGetOneGet(cdorder?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderOutputDto>>;
    public apiOrderGetOneGet(cdorder?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderOutputDto>>;
    public apiOrderGetOneGet(cdorder?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdorder !== undefined && cdorder !== null) {
            queryParameters = queryParameters.set('cdorder', <any>cdorder);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OrderOutputDto>('get', `${this.basePath}/api/Order/GetOne`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdDelivery 
     * @param dtFrom 
     * @param dtTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetOrdersByDeliveryAndDateGet(cdDelivery: number, dtFrom?: Date, dtTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<OrderForDeliveryPayingDto>>;
    public apiOrderGetOrdersByDeliveryAndDateGet(cdDelivery: number, dtFrom?: Date, dtTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderForDeliveryPayingDto>>>;
    public apiOrderGetOrdersByDeliveryAndDateGet(cdDelivery: number, dtFrom?: Date, dtTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderForDeliveryPayingDto>>>;
    public apiOrderGetOrdersByDeliveryAndDateGet(cdDelivery: number, dtFrom?: Date, dtTo?: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cdDelivery === null || cdDelivery === undefined) {
            throw new Error('Required parameter cdDelivery was null or undefined when calling apiOrderGetOrdersByDeliveryAndDateGet.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdDelivery !== undefined && cdDelivery !== null) {
            queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
        }
        if (dtFrom !== undefined && dtFrom !== null) {
            queryParameters = queryParameters.set('dtFrom', <any>dtFrom.toISOString());
        }
        if (dtTo !== undefined && dtTo !== null) {
            queryParameters = queryParameters.set('dtTo', <any>dtTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderForDeliveryPayingDto>>('get', `${this.basePath}/api/Order/GetOrdersByDeliveryAndDate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdDelivery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetOrdersByDeliveryGet(cdDelivery: number, observe?: 'body', reportProgress?: boolean): Observable<DeliveryStartOrdersDto>;
    public apiOrderGetOrdersByDeliveryGet(cdDelivery: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeliveryStartOrdersDto>>;
    public apiOrderGetOrdersByDeliveryGet(cdDelivery: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeliveryStartOrdersDto>>;
    public apiOrderGetOrdersByDeliveryGet(cdDelivery: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cdDelivery === null || cdDelivery === undefined) {
            throw new Error('Required parameter cdDelivery was null or undefined when calling apiOrderGetOrdersByDeliveryGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdDelivery !== undefined && cdDelivery !== null) {
            queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeliveryStartOrdersDto>('get', `${this.basePath}/api/Order/GetOrdersByDelivery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param dtFrom 
     * @param dtTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetOrdersByStoreAndDateGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<OrderForStorePayingDto>>;
    public apiOrderGetOrdersByStoreAndDateGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderForStorePayingDto>>>;
    public apiOrderGetOrdersByStoreAndDateGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderForStorePayingDto>>>;
    public apiOrderGetOrdersByStoreAndDateGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cdStore === null || cdStore === undefined) {
            throw new Error('Required parameter cdStore was null or undefined when calling apiOrderGetOrdersByStoreAndDateGet.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }
        if (dtFrom !== undefined && dtFrom !== null) {
            queryParameters = queryParameters.set('dtFrom', <any>dtFrom.toISOString());
        }
        if (dtTo !== undefined && dtTo !== null) {
            queryParameters = queryParameters.set('dtTo', <any>dtTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderForStorePayingDto>>('get', `${this.basePath}/api/Order/GetOrdersByStoreAndDate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdDelivery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetOrdersForReceiptGet(cdDelivery?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OrderReceiptDto>>;
    public apiOrderGetOrdersForReceiptGet(cdDelivery?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrderReceiptDto>>>;
    public apiOrderGetOrdersForReceiptGet(cdDelivery?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrderReceiptDto>>>;
    public apiOrderGetOrdersForReceiptGet(cdDelivery?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdDelivery !== undefined && cdDelivery !== null) {
            queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrderReceiptDto>>('get', `${this.basePath}/api/Order/GetOrdersForReceipt`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdDelivery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderGetPendingPayinmentsByDeliveryGet(cdDelivery?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<PendingPaymentsDto>>;
    public apiOrderGetPendingPayinmentsByDeliveryGet(cdDelivery?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PendingPaymentsDto>>>;
    public apiOrderGetPendingPayinmentsByDeliveryGet(cdDelivery?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PendingPaymentsDto>>>;
    public apiOrderGetPendingPayinmentsByDeliveryGet(cdDelivery?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdDelivery !== undefined && cdDelivery !== null) {
            queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PendingPaymentsDto>>('get', `${this.basePath}/api/Order/GetPendingPayinmentsByDelivery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderLastFiftyGet(observe?: 'body', reportProgress?: boolean): Observable<Array<LastOrdersDto>>;
    public apiOrderLastFiftyGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LastOrdersDto>>>;
    public apiOrderLastFiftyGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LastOrdersDto>>>;
    public apiOrderLastFiftyGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<LastOrdersDto>>('get', `${this.basePath}/api/Order/LastFifty`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderOnTheWayPut(cdOrder?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOrderOnTheWayPut(cdOrder?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOrderOnTheWayPut(cdOrder?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOrderOnTheWayPut(cdOrder?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put', `${this.basePath}/api/Order/OnTheWay`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderPostOrderPost(body?: OrderPostDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiOrderPostOrderPost(body?: OrderPostDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiOrderPostOrderPost(body?: OrderPostDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiOrderPostOrderPost(body?: OrderPostDto, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post', `${this.basePath}/api/Order/PostOrder`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderRejectDeliveryPut(cdOrder?: number, observe?: 'body', reportProgress?: boolean): Observable<OrderOutputDto>;
    public apiOrderRejectDeliveryPut(cdOrder?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderOutputDto>>;
    public apiOrderRejectDeliveryPut(cdOrder?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderOutputDto>>;
    public apiOrderRejectDeliveryPut(cdOrder?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OrderOutputDto>('put', `${this.basePath}/api/Order/RejectDelivery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param dsNotes 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderRejectOrderPut(cdOrder?: number, dsNotes?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOrderRejectOrderPut(cdOrder?: number, dsNotes?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOrderRejectOrderPut(cdOrder?: number, dsNotes?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOrderRejectOrderPut(cdOrder?: number, dsNotes?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }
        if (dsNotes !== undefined && dsNotes !== null) {
            queryParameters = queryParameters.set('dsNotes', <any>dsNotes);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put', `${this.basePath}/api/Order/RejectOrder`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdOrder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderReturnDeliveryPut(cdOrder?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOrderReturnDeliveryPut(cdOrder?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOrderReturnDeliveryPut(cdOrder?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOrderReturnDeliveryPut(cdOrder?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdOrder !== undefined && cdOrder !== null) {
            queryParameters = queryParameters.set('cdOrder', <any>cdOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put', `${this.basePath}/api/Order/ReturnDelivery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param dtFrom 
     * @param dtTo 
     * @param nmStatus 
     * @param filter 
     * @param nmPaymentMethod 
     * @param isShipping 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderStoreReportsGet(cdStore?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: EnumsOrderState, filter?: number, nmPaymentMethod?: EnumsPaymentMethod, isShipping?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<SalesStoreReportDto>>;
    public apiOrderStoreReportsGet(cdStore?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: EnumsOrderState, filter?: number, nmPaymentMethod?: EnumsPaymentMethod, isShipping?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SalesStoreReportDto>>>;
    public apiOrderStoreReportsGet(cdStore?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: EnumsOrderState, filter?: number, nmPaymentMethod?: EnumsPaymentMethod, isShipping?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SalesStoreReportDto>>>;
    public apiOrderStoreReportsGet(cdStore?: number, dtFrom?: Date, dtTo?: Date, nmStatus?: EnumsOrderState, filter?: number, nmPaymentMethod?: EnumsPaymentMethod, isShipping?: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {








        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('CdStore', <any>cdStore);
        }
        if (dtFrom !== undefined && dtFrom !== null) {
            queryParameters = queryParameters.set('DtFrom', <any>dtFrom.toISOString());
        }
        if (dtTo !== undefined && dtTo !== null) {
            queryParameters = queryParameters.set('DtTo', <any>dtTo.toISOString());
        }
        if (nmStatus !== undefined && nmStatus !== null) {
            queryParameters = queryParameters.set('NmStatus', <any>nmStatus);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('Filter', <any>filter);
        }
        if (nmPaymentMethod !== undefined && nmPaymentMethod !== null) {
            queryParameters = queryParameters.set('NmPaymentMethod', <any>nmPaymentMethod);
        }
        if (isShipping !== undefined && isShipping !== null) {
            queryParameters = queryParameters.set('IsShipping', <any>isShipping);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SalesStoreReportDto>>('get', `${this.basePath}/api/Order/StoreReports`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderTotalOrdersByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<TotalOrdersDto>;
    public apiOrderTotalOrdersByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TotalOrdersDto>>;
    public apiOrderTotalOrdersByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TotalOrdersDto>>;
    public apiOrderTotalOrdersByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TotalOrdersDto>('get', `${this.basePath}/api/Order/TotalOrdersByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdUser 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOrderUserOrdersGet(cdUser?: number, cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<UserOrdersDto>>;
    public apiOrderUserOrdersGet(cdUser?: number, cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserOrdersDto>>>;
    public apiOrderUserOrdersGet(cdUser?: number, cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserOrdersDto>>>;
    public apiOrderUserOrdersGet(cdUser?: number, cdStore?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserOrdersDto>>('get', `${this.basePath}/api/Order/UserOrders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
